import React, { useEffect } from 'react';
import { useDashboardData } from '../../../Context/DashboardContext/dashboardContext';
import './OrderDetails.css';
import grothChartIcon from '../../../Assets/Images/groth-chart-icon.jpeg';
import lineChartIcon from '../../../Assets/Images/line-chart-icon.jpeg';

const OrderDetails = () => {
  // Access the context data and fetch function
  const { orderInsights, loading, error, fetchInsights } = useDashboardData();

  // Format price as currency
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-us', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: price % 1 === 0 ? 0 : 2, // Show decimals only if necessary
      maximumFractionDigits: 2, // Limit to 2 decimal places
    }).format(price);
  };

  // Use effect to fetch data if it's not already present
  useEffect(() => {
    if (!orderInsights.newOrders) {
      fetchInsights(); // Call the fetch function if data is not available
    }
  }, [orderInsights, fetchInsights]);

  // Data for displaying, fallback to context values if available
  const ordersDetailsData = [
    { name: 'New Orders', val: orderInsights.newOrders, chartIcon: grothChartIcon },
    { name: 'Completed Orders', val: orderInsights.completedOrders, chartIcon: grothChartIcon },
    { name: 'Processing Orders', val: orderInsights.processingOrders, chartIcon: grothChartIcon },
    { name: 'Canceled Orders', val: orderInsights.cancelledOrders, chartIcon: lineChartIcon },
    { name: 'Total Sales', val: orderInsights.totalSale },
    { name: 'Net Sales', val: orderInsights.netSale },
    { name: 'Average Order Value', val: orderInsights.averageSale },
  ];

  return (
    <div className='order-details-main-container'>
      {loading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>Error: {error}</p>
      ) : (
        ordersDetailsData.map((item, index) => (
          <div className='single-order-detail-container' key={index}>
            <p>{item.name}</p>
            <div className='order-value-and-chart-icon--container'>
              <p>{index > 3 ? formatPrice(item.val) : item.val}</p>
              {item.chartIcon && <img src={item.chartIcon} alt='chart-icon' />}
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default OrderDetails;
